/**
 * ActiveGroupNotice — small informational chip showing the current
 * group on create-side pages. Read-only by design: switching groups
 * happens via the single header dropdown, never per-page. Renders
 * nothing when the user belongs to a single writeable group (the
 * header already says the same thing) or has zero (the header shows
 * an "ingen grupp" warning).
 *
 * Re-exports `useActiveGroup` so consumer pages don't need a second
 * import.
 */

import { useActiveGroup } from '../active-group-context.js';

export { useActiveGroup };

export function ActiveGroupNotice(props: {
  /** Verb fragment, e.g. "Skapas i" (default), "Importeras till". */
  prefix?: string;
}) {
  const { writeableGroups, activeGroupId, loading } = useActiveGroup();

  if (loading || writeableGroups === null) return null;
  // Header already conveys the active group in these cases.
  if (writeableGroups.length <= 1) return null;

  const active = writeableGroups.find((g) => g.id === activeGroupId);
  if (!active) return null;

  return (
    <span className="inline-flex items-center gap-2 text-[11px] text-stone-500">
      <span className="uppercase tracking-[0.16em] text-stone-400">
        {props.prefix ?? 'Skapas i'}
      </span>
      <span className="rounded-full bg-stone-100 px-2.5 py-0.5 font-medium text-stone-700">
        {active.name}
      </span>
      <span className="text-stone-400">
        (byt i topplisten)
      </span>
    </span>
  );
}
